export default {
  components: {
  },
  data() {
    return {
      arr: [{name: '地块信息', key: 'landInfo'}, {name: '项目基本信息', key: 'basicInfo'}, {name: '受让方资格条件', key: 'transfereeInfo'}],
      activeKey: 'landInfo',
      navTop: null
    };
  },
  created() {
  },
  computed: {
  },
  mounted () {
    this.$nextTick(function () {
      this.navTop = document.getElementById('navList').offsetTop;
      window.addEventListener('scroll', this.handleScroll);
    });
  },
  methods: {
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 获取滑动距离
      const landInfoScrollHeight = document.getElementById('landInfo').offsetTop;
      const basicInfoScrollHeight = document.getElementById('basicInfo').offsetTop;
      const transfereeInfoScrollHeight = document.getElementById('transfereeInfo') && document.getElementById('transfereeInfo').offsetTop;
      if (scrollTop > this.navTop) {
        document.getElementById('navList').style = 'position: fixed';
      } else if (scrollTop < (this.navTop - 43)) {
        document.getElementById('navList').style = 'position: relative';
      }
      if (scrollTop >= (transfereeInfoScrollHeight - 43)) {
        this.activeKey = 'transfereeInfo';
      } else if (scrollTop >= (basicInfoScrollHeight - 43)) {
        this.activeKey = 'basicInfo';
      } else if (scrollTop >= (landInfoScrollHeight -43)) {
        this.activeKey = 'landInfo';
      }
    },
    changeActiveIndex (key) {
      this.activeKey = key;
      document.body.scrollTop = document.documentElement.scrollTop = (document.getElementById(key).offsetTop - 43);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
